import React, { useContext } from 'react'
import styles from './index.module.less'

import Buyer from './buyer'
import Seller from './seller'
import context from '../../context'

export default function Superior() {
  const { equity } = useContext(context)
  return (
    <div className={styles.superior}>
      {equity !== 'seller' && <Buyer />}
      <Seller />
      <div className={styles.copyright}>
        <i className={styles.brand}></i>
      </div>
    </div>
  )
}
